import { createSlice } from '@reduxjs/toolkit';
import { asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { getAllRefunds, getRefundFulfilled } from './refunds_thunk';

const initialState = {
  refunds: [],
  status: '',
  message: ''
}

export const refundSlice = createSlice({
  name: 'refunds',
  initialState,
  reducers: {
    clearRefundState: (state) => {
      state.refunds = [];
    }
  },
  extraReducers: {
    [getAllRefunds.pending]: asyncIsPending,
    [getAllRefunds.rejected]: asyncIsRejected,
    [getAllRefunds.fulfilled]: getRefundFulfilled,
  }
});

export const { clearRefundState } = refundSlice.actions;
export default refundSlice.reducer;